import customAxios from "../index";
import qs from "qs";

export const getProviderRequests = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/admin/provider-requests",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getProviderRequestDetails = (id: string) => {
  return customAxios({
    method: "GET",
    url: `/admin/provider-requests-details/${id}`,
  });
};

export const approveProviderRequest = (id: string) => {
  return customAxios({
    method: "POST",
    url: `/admin/provider-requests/approve/${id}`,
  });
};

export const rejectProviderRequest = (id: string, data: any) => {
  return customAxios({
    method: "POST",
    url: `/admin/provider-requests/reject/${id}`,
    data,
  });
};

// PROVIDER MANAGEMENT ENDPOINTS

export const getProviderProfiles = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/admin/providers",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getProviderProfileDetails = (providerId: number) => {
  return customAxios({
    method: "GET",
    url: `/admin/providers/profile-details/${providerId}`,
  });
};

//planner management endpoints
export const getPlannerProfilePackagesDetails = (plannerId: number) => {
  return customAxios({
    method: "GET",
    url: `/admin/planners/profile-details/${plannerId}`,
  });
};
export const updatePackageCommissionForPlanner = (
  id: string,
  packageId: string,
  data: any,
) => {
  return customAxios({
    method: "PUT",
    url: `/admin/planners/profile-details/${id}/packages/${packageId}/commission`,
    data,
  });
};

// Update provider need types (e.g. pre_need / at_need)
export const updateProviderNeedTypes = (
  providerId: number,
  data: { needTypes: string[] },
) => {
  return customAxios({
    method: "PUT",
    url: `/admin/providers/profile-details/${providerId}`,
    data,
  });
};
export const searchPartnerToLink = ({
  type,
  value,
}: {
  type: string;
  value: string;
}) => {
  return customAxios({
    method: "GET",
    url: `/admin/crm-partner/search`,
    params: {
      type,
      value,
    },
  });
};
export const linkPartnerOrPlanner = (
  sourceId: number,
  crmPartner: {
    id: number;
    companyName: string;
    email: string;
    phoneNumber: string;
  },
) => {
  return customAxios({
    method: "POST",
    url: `/admin/crm-partner/link/${sourceId}`,
    data: {
      crmPartner: crmPartner,
    },
  });
};
